















import Vue from "vue";
import InputNumber from "@/encoding/components/buildingBlocks/InputNumber.vue";

export default Vue.extend({
    components: {
        InputNumber: InputNumber
    },
    data: function() {
        return {
            pathInStore: "property.outdoor.terrace.surface"
        };
    },
    computed: {
        terraceSurface: function(): string|null {
            return this.$store.getters["FormModule/getValue"](this.pathInStore);
        },
        isDisplayed: function(): boolean {
            return this.$store.getters["FormModule/getValue"]("property.outdoor.terrace.exists") === true;
        }
    },
    mounted: function() {
        if (!this.isDisplayed) {
            this.$store.commit("FormModule/deleteValue", this.pathInStore);
        }
    },
    methods: {
        updateValue: function(terraceSurface: number): void {
            if (terraceSurface == 0 && this.$store.getters["FormModule/getValue"](this.pathInStore) != null) {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": terraceSurface});
            }
        }
    }
});

